import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => ({
    container: {
        width: "100%",
        maxWidth: 1280,
        margin: theme.spacing(0, "auto", 0),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            width: "90%",
            display: "flex",
            justifyContent: "center",
        },
    },
    card: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        backgroundColor: theme.palette.tertiary.main,
        borderRadius: 32,
        overflow: "hidden",
        marginInline: theme.spacing(4),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            flexDirection: "column",
            alignItems: "center",
            marginInline: 0,
            maxWidth: 600,
        },
    },
    content: {
        display: "flex",
        flexDirection: "column",
        maxWidth: 703,
        gap: theme.spacing(2),
        padding: theme.spacing(5, 4, 5, 6),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.SMALL_MOBILE)]: {
            padding: theme.spacing(2),
        },
    },
    badge: {
        width: "fit-content",
        backgroundColor: theme.palette.quaternary.main,
        borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
        color: theme.palette.secondary.main,
        padding: theme.spacing(0.5, 3, 0, 3),
        fontWeight: theme.typography.fontWeightBold,
    },
    actionContainer: {
        marginTop: theme.spacing(1),
    },
    image: {
        width: 433,
        maxWidth: "100%",
        display: "block",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            width: 349,
        },
    },
}));
